import { HubStorageCapacityStatus } from '@robovision/hub'


export const STATUS_PRIORITY: HubStorageCapacityStatus[] = [
  HubStorageCapacityStatus.ALARM,
  HubStorageCapacityStatus.WARNING,
]
